import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { cn } from '@/lib/utils'

export function SocialAvatar({
  name,
  className,
}: {
  name: string
  className?: string
}) {
  const fallback = name.trim().slice(0, 2).toLocaleUpperCase() || '?'
  return (
    <Avatar className={cn('size-9', className)}>
      <AvatarFallback className="bg-primary/10 text-xs font-semibold text-primary">
        {fallback}
      </AvatarFallback>
    </Avatar>
  )
}
